import dayjs from 'dayjs';

export const INVENTORY_CONVERSION_TYPE_CONFIG = {
  ASSEMBLY: {
    label: 'Összeállítás',
    marker: '🟢',
    color: '#1b5e20',
    backgroundColor: '#e8f5e9',
    borderColor: '#81c784',
  },
  DISASSEMBLY: {
    label: 'Bontás',
    marker: '🔵',
    color: '#0d47a1',
    backgroundColor: '#e3f2fd',
    borderColor: '#64b5f6',
  },
  DEFAULT: {
    label: 'Ismeretlen',
    marker: '⚪',
    color: '#424242',
    backgroundColor: '#f5f5f5',
    borderColor: '#bdbdbd',
  },
};

export const getInventoryConversionTypeConfig = (conversionType) => {
  return INVENTORY_CONVERSION_TYPE_CONFIG[conversionType] ?? INVENTORY_CONVERSION_TYPE_CONFIG.DEFAULT;
};

export const getInventoryConversionItemLabel = (data) => {
  return [data?.itemCode, data?.item?.itemName ?? data?.itemName].filter(Boolean).join(' - ');
};

export const getInventoryConversionUnitCode = (data) => {
  return data?.quantityUnitCode ?? data?.item?.quantityUnit?.code ?? data?.quantityUnit?.code ?? '';
};

export const getInventoryConversionWarehouseLabel = (data) => {
  const fallbackRow = data?.issues?.[0] ?? data?.receipts?.[0] ?? data?.inventoryConversionLine?.[0] ?? null;
  const whsCode = data?.whsCode ?? data?.doc?.whsCode ?? fallbackRow?.whsCode ?? fallbackRow?.doc?.whsCode ?? null;
  const warehouseName =
    data?.warehouse?.name ?? data?.doc?.warehouse?.name ?? fallbackRow?.warehouse?.name ?? fallbackRow?.doc?.warehouse?.name ?? null;

  return [whsCode, warehouseName].filter(Boolean).join(' - ');
};

export const getInventoryConversionBinLabel = (data) => {
  const fallbackRow = data?.issues?.[0] ?? data?.receipts?.[0] ?? data?.inventoryConversionLine?.[0] ?? null;

  return (
    data?.bin?.binCode ??
    data?.doc?.bin?.binCode ??
    data?.binCode ??
    data?.binId ??
    data?.toBinId ??
    fallbackRow?.bin?.binCode ??
    fallbackRow?.doc?.bin?.binCode ??
    fallbackRow?.binCode ??
    fallbackRow?.binId ??
    fallbackRow?.toBinId ??
    ''
  );
};

export const getInventoryConversionCreatedByLabel = (data, users = []) => {
  const createdBy = data?.createdBy ?? data?.userId ?? data?.reportedBy ?? null;
  if (data?.user?.nickName) return data.user.nickName;
  if (data?.user?.name) return data.user.name;
  if (data?.createdByUser?.nickName) return data.createdByUser.nickName;
  if (data?.createdByUser?.name) return data.createdByUser.name;
  if (createdBy == null) return '';

  const matchedUser = users.find((user) => user.userId === createdBy);
  if (!matchedUser) return String(createdBy);

  return matchedUser.nickName || matchedUser.name || matchedUser.userName || matchedUser.email || String(createdBy);
};

export const getInventoryConversionDocDate = (data) => {
  const rawDate = data?.docDate ?? data?.createdDate ?? data?.createDate ?? data?.createdAt ?? null;
  if (!rawDate) return '';

  const parsedDate = dayjs(rawDate);
  return parsedDate.isValid() ? parsedDate.format('YYYY.MM.DD HH:mm') : '';
};

export const getInventoryConversionLines = (selectedValues) => {
  return selectedValues?.inventoryConversionLine ?? [];
};

export const getInventoryConversionIssues = (selectedValues) => {
  return selectedValues?.issues ?? selectedValues?.issue ?? selectedValues?.outgoing ?? [];
};

export const getInventoryConversionReceipts = (selectedValues) => {
  return selectedValues?.receipts ?? selectedValues?.receipt ?? selectedValues?.incoming ?? [];
};
